'use strict'

const isError_ = require('lodash/isError')
const isPromise = require('dbsm-common/src/isPromise')

const { isDatasetError } = require('../dataset-controller/DatasetError')

const USER_SCOPE = 'user-scope'
const APPLICATION_SCOPE = 'application-scope'
const WIX_DATA_SCOPE = 'wix-data-scope'
const WIX_DATA_USER_ERROR_CODES = ['WD_SITE_IN_TEMPLATE_MODE', 'WD_PERMISSION_DENIED']

const handled = Symbol('error was handled')

const isErrorHandled = e => e[handled]

const isUserError = (error, scope) =>
  isDatasetError(error.name) ||
  scope === USER_SCOPE ||
  (scope === WIX_DATA_SCOPE && WIX_DATA_USER_ERROR_CODES.includes(error.code))

const handleError = (e, scope, {Raven, UserRaven}) => {
  if (!isError_(e) || isErrorHandled(e)) {
    return
  }
  if (isUserError(e, scope)) {
    e[handled] = true
    UserRaven.captureException(e)
  } else if (scope === APPLICATION_SCOPE) {
    e[handled] = true
    Raven.captureException(e)
  }
}

const errorScopingFactory = (ravenInstances, scope) => func => (...args) => {
  try {
    const result = func(...args)
    if (isPromise(result)) {
      result.catch(e => handleError(e, scope, ravenInstances))
    }

    return result
  } catch (e) {
    handleError(e, scope, ravenInstances)
    throw e
  }
}

module.exports = ravenInstances => {
  return {
    userCodeZone: errorScopingFactory(ravenInstances, USER_SCOPE),
    applicationCodeZone: errorScopingFactory(ravenInstances, APPLICATION_SCOPE),
    wixDataCodeZone: errorScopingFactory(ravenInstances, WIX_DATA_SCOPE)
  }
}

module.exports.isErrorHandled = isErrorHandled



// WEBPACK FOOTER //
// ./error-boundaries/errorBoundaries.js